import React, { FC } from 'react';
import styled from 'styled-components';
import { colors } from 'src/config/colors';
import { typography } from 'src/config/typography';
import { IconProps } from 'src/lib/IconBox';

const StyledIcon = styled.svg``;

const SummaryIcon = styled.div`
  align-items: center;
  background: ${colors.grey05};
  border-radius: 100%;
  display: inline-flex;
  justify-content: center;
  height: 2rem;
  margin-right: 0.625rem;
  margin-top: 0.1875rem;
  width: 2rem;
`;

const SummaryItem = styled.div`
  flex: 0 0 auto;
  padding: 0 1.25rem;
`;

const SummaryTitle = styled.div`
  color: ${colors.blue};
  font-family: ${typography.fontFamilyHeaders};
  font-size: 1rem;
  line-height: 1.375rem;
  margin-top: -0.5rem;
  white-space: nowrap;
`;

const SummaryValue = styled.div`
  color: ${colors.blue};
  display: flex;
  font-family: ${typography.fontFamilyHeaders};
  font-size: 2.3125rem;
  line-height: 2.875rem;
`;

export interface UserCoursesSummaryItemType {
  icon: FC<IconProps>;
  title: string;
  value?: number;
}

export interface UserCoursesSummaryItemProps {
  item: UserCoursesSummaryItemType;
}

export const UserCoursesSummaryItem: FC<UserCoursesSummaryItemProps> = ({ item }) => (
  <SummaryItem>
    <SummaryValue>
      <SummaryIcon>
        <StyledIcon as={item.icon} size={18} />
      </SummaryIcon>
      {item.value ?? '-'}
    </SummaryValue>
    <SummaryTitle dangerouslySetInnerHTML={{ __html: item.title }} />
  </SummaryItem>
);
